export const SHOW_ALERT = 'show alert';
export const HIDE_ALERT = 'hide alert';

export const showAlertAction = (params) => dispatch => {

  dispatch({
    type: SHOW_ALERT,
    payload: params
  })

  setTimeout(
    () => {
      dispatch({
        type: HIDE_ALERT
      })
    },
    6000
  );
}

export const hideAlertAction = () => dispatch => {
  dispatch({
    type: HIDE_ALERT
  })
}